/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import CountyService from '../../services/CountyService';
import { US_STATES } from '../../constants/formOptions';
import useForm from '../utils/useForm';

const usePropertyForm = (onSubmit, values, readOnly) => {
  const fields = useMemo(
    () => [
      {
        title: 'Property Information',
        fields: [
          {
            title: 'Type',
            name: 'type',
            type: 'select',
            options: [
              {
                value: 'Single Family Residential',
                label: 'Single Family Residential',
              },
              { value: 'Commercial', label: 'Commercial' },
              {
                value: 'Land',
                label: 'Land',
              },
              {
                value: 'Mixed Use',
                label: 'Mixed Use',
              },
            ],
          },
          {
            title: 'Appraised Value',
            name: 'appraised_value',
            type: 'currency',
          },
          {
            title: 'Appraisal date',
            name: 'appraisal_date',
            type: 'date',
          },
          {
            title: 'Land value',
            name: 'land_value',
            type: 'currency',
          },
          {
            title: 'Address Line 1',
            name: 'address_line_1',
            type: 'text',
            required: true,
          },
          {
            title: 'Address Line 2',
            name: 'address_line_2',
            type: 'text',
          },
          {
            title: 'City',
            name: 'city',
            type: 'text',
            required: true,
          },
          {
            title: 'State',
            name: 'state',
            type: 'select',
            options: US_STATES,
            required: true,
          },
          {
            title: 'ZIP',
            name: 'zip',
            type: 'text',
            validation: 'zip',
            required: true,
          },
          {
            title: 'County',
            name: 'county_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['counties'],
              queryFn: CountyService.getCounties,
              labelKey: 'name',
            },
            required: true,
          },
          {
            title: 'Flood zone',
            name: 'flood',
            type: readOnly ? 'text' : 'checkbox',
            format: readOnly ? (vals) => (vals?.flood ? 'Yes' : 'No') : null,
          },
          {
            title: 'Flood Zone Category',
            name: 'flood_zone_category',
            type: 'select',
            options: [
              {
                label: 'A',
                value: 'A',
              },
              {
                label: 'AE',
                value: 'AE',
              },
              {
                label: 'X500',
                value: 'X500',
              },
            ],
            isHidden: (vals) => {
              return !vals.flood;
            },
          },
          {
            title: 'Legal Description',
            name: 'legal_description',
            type: 'textarea',
            className: 'md:col-start-1 md:col-end-5',
            rows: 7,
          },
        ],
      },
    ],
    [readOnly]
  );

  return useForm({ fields, onSubmit, values });
};

export default usePropertyForm;
